<app-navbar />
<app-banner />
<main>
  <div [class]="isFullWidth() ? '' : 'max-w-7xl mx-auto p-component-3 md:p-layout-2 pb-0'">
    <router-outlet />
  </div>
</main>
<app-error-dialog />
